<template>
    <!-- Wallet Card with Summary -->
    <div class="section pt-1">
        <div class="wallet-card">
            <!-- Balance -->
            <div class="balance">
                <div class="left">
                    <span class="title">Total Election Officers</span>
                    <h1 class="total text-primary">{{ totalOfficersCount }}</h1>
                </div>
                <div class="right">
                    <div class="chart-container">
                        <apexchart 
                            ref="chart"
                            type="pie" 
                            width="400" 
                            :options="chartOptions" 
                            :series="series"
                        ></apexchart>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Wing Summary Stats -->
    <div class="section">
        <div class="row mt-1">
            <div class="col-4 col-md-2">
                <div class="stat-box">
                    <div class="title">Wisdom</div>
                    <div class="value text-primary">{{ totalCounts.wisdom }}</div>
                </div>
            </div>
            <div class="col-4 col-md-2">
                <div class="stat-box">
                    <div class="title">Youth</div>
                    <div class="value text-success">{{ totalCounts.youth }}</div>
                </div>
            </div>
            <div class="col-4 col-md-2">
                <div class="stat-box">
                    <div class="title">Students</div>
                    <div class="value text-warning">{{ totalCounts.students }}</div>
                </div>
            </div>
            <div class="col-4 col-md-2">
                <div class="stat-box">
                    <div class="title">Women</div>
                    <div class="value text-danger">{{ totalCounts.women }}</div>
                </div>
            </div>
            <div class="col-4 col-md-2">
                <div class="stat-box">
                    <div class="title">Girls</div>
                    <div class="value text-info">{{ totalCounts.girls }}</div>
                </div>
            </div>
            <div class="col-4 col-md-2">
                <div class="stat-box">
                    <div class="title">Balavedi</div>
                    <div class="value text-secondary">{{ totalCounts.balavedi }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="section pt-0 mt-0">
        <div class="listed-detail">
            <h3 class="text-center mt-2 custom-title">{{ pageTitle }}</h3>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="listed-detail mt-0">
        <h4 class="text-center mt-0" v-if="!loading_list && member_lists.length <= 0">{{ noDataMessage }}</h4>
    </div>

    <!-- Sub Levels Table -->
    <div class="section mt-2 mb-2" v-if="!loading_list">
        <div class="card">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">{{ levelName }}</th>
                            <th scope="col">W</th>
                            <th scope="col">Y</th>
                            <th scope="col">S</th>
                            <th scope="col">WS</th>
                            <th scope="col">G</th>
                            <th scope="col">B</th>
                            <th scope="col">Total</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="sub_level in member_lists" :key="sub_level.id">
                            <!-- For State/District/Zone Admin - Link to next level report -->
                            <td class="text-primary font-dark" v-if="user_level <= 2">
                                <router-link
                                    :to="'/org/' + (user_level + 1) + '/' + sub_level.id + '/election-officers-report'">
                                    {{ sub_level.name }}
                                </router-link>
                            </td>
                            <!-- For Zone Admin - Link to unit officers list -->
                            <td class="text-primary font-dark" v-if="user_level == 3">
                                <router-link :to="'/org/' + (user_level + 1) + '/' + sub_level.id + '/election-officers-list'">
                                    {{ sub_level.name }}
                                </router-link>
                            </td>
                            <td class="text-primary font-dark">
                                {{ sub_level.counts.wisdom || 0 }}
                            </td>
                            <td class="text-success font-dark">
                                {{ sub_level.counts.youth || 0 }}
                            </td>
                            <td class="text-warning font-dark">
                                {{ sub_level.counts.students || 0 }}
                            </td>
                            <td class="text-danger font-dark">
                                {{ sub_level.counts.women || 0 }}
                            </td>
                            <td class="text-info font-dark">
                                {{ sub_level.counts.girls || 0 }}
                            </td>
                            <td class="text-secondary font-dark">
                                {{ sub_level.counts.balavedi || 0 }}
                            </td>
                            <td class="text-primary font-dark">
                                <strong>{{ sub_level.totalOfficers }}</strong>
                            </td>
                            <td class="text-primary font-dark">
                                <div class="card-button dropdown">
                                    <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                                        :data-bs-target="'#actionSheetInset' + sub_level.id">
                                        <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                                    </button>
                                </div>
                                <div class="modal fade action-sheet" :id="'actionSheetInset' + sub_level.id"
                                    tabindex="-1" role="dialog">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title">Action</h5>
                                            </div>
                                            <div class="modal-body">
                                                <ul class="action-button-list">
                                                    <li v-if="currentUser.user_level <= 3">
                                                        <a href="javascript:void(0)" class="btn btn-list"
                                                            data-bs-dismiss="modal" @click="viewDetails(sub_level)">
                                                            <span>
                                                                <ion-icon name="eye-outline"></ion-icon> View Details
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="action-divider"></li>
                                                    <li>
                                                        <a href="#" class="btn btn-list text-danger"
                                                            data-bs-dismiss="modal">
                                                            <span>
                                                                <ion-icon name="close-outline"></ion-icon> Cancel
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ElectionOfficersReport',
    data() {
        return {
            loading_list: false,
            user_level: 1,
            unit_id: null,
            member_lists: [],
            totalCounts: {
                wisdom: 0,
                youth: 0,
                students: 0,
                women: 0,
                girls: 0,
                balavedi: 0
            },
            series: [0, 0, 0, 0, 0, 0],
            chartOptions: {
                chart: {
                    width: '100%',
                    type: 'pie',
                },
                colors: ['#007bff', '#28a745', '#ffc107', '#dc3545', '#17a2b8', '#6c757d'],
                labels: ['Wisdom', 'Youth', 'Students', 'Women', 'Girls', 'Balavedi'],
                legend: {
                    position: 'bottom'
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 300
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            }
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        totalOfficersCount() {
            return this.totalCounts.wisdom + this.totalCounts.youth + 
                   this.totalCounts.students + this.totalCounts.women + 
                   this.totalCounts.girls + this.totalCounts.balavedi;
        },
        levelName() {
            if (this.user_level === 1) return 'District';
            if (this.user_level === 2) return 'Zone';
            if (this.user_level === 3) return 'Unit';
            return 'Level';
        },
        pageTitle() {
            if (this.user_level === 1) return 'Election Officers Report';
            if (this.user_level === 2) return 'District - Zone wise Report';
            if (this.user_level === 3) return 'Zone - Unit wise Report';
            return 'Election Officers Report';
        },
        noDataMessage() {
            if (this.user_level === 1) return 'No districts found';
            if (this.user_level === 2) return 'No zones found';
            if (this.user_level === 3) return 'No units found';
            return 'No data found';
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level) || 1;
            this.unit_id = parseInt(this.$route.params.id) || null;
            this.getElectionOfficersReport();
            this.$root.updateParent('Election Officers Report');
        }
    },
    methods: {
        getElectionOfficersReport() {
            this.loading_list = true;
            
            // Static mock data based on user_level
            if (this.user_level === 1) {
                this.member_lists = [
                    {
                        id: 1,
                        name: 'Thiruvananthapuram',
                        counts: { wisdom: 25, youth: 18, students: 32, women: 15, girls: 22, balavedi: 8 },
                        totalOfficers: 120
                    },
                    {
                        id: 2,
                        name: 'Kollam',
                        counts: { wisdom: 22, youth: 16, students: 28, women: 12, girls: 18, balavedi: 6 },
                        totalOfficers: 102
                    },
                    {
                        id: 3,
                        name: 'Pathanamthitta',
                        counts: { wisdom: 18, youth: 14, students: 24, women: 10, girls: 16, balavedi: 5 },
                        totalOfficers: 87
                    },
                    {
                        id: 4,
                        name: 'Alappuzha',
                        counts: { wisdom: 28, youth: 20, students: 35, women: 18, girls: 25, balavedi: 9 },
                        totalOfficers: 135
                    },
                    {
                        id: 5,
                        name: 'Kottayam',
                        counts: { wisdom: 24, youth: 17, students: 30, women: 14, girls: 20, balavedi: 7 },
                        totalOfficers: 112
                    }
                ];
                this.totalCounts = { wisdom: 117, youth: 85, students: 149, women: 69, girls: 101, balavedi: 35 };
            } else if (this.user_level === 2) {
                this.member_lists = [
                    {
                        id: 1,
                        name: 'Zone A',
                        counts: { wisdom: 12, youth: 8, students: 15, women: 7, girls: 10, balavedi: 4 },
                        totalOfficers: 56
                    },
                    {
                        id: 2,
                        name: 'Zone B',
                        counts: { wisdom: 10, youth: 6, students: 12, women: 5, girls: 8, balavedi: 3 },
                        totalOfficers: 44
                    },
                    {
                        id: 3,
                        name: 'Zone C',
                        counts: { wisdom: 8, youth: 5, students: 10, women: 4, girls: 6, balavedi: 2 },
                        totalOfficers: 35
                    }
                ];
                this.totalCounts = { wisdom: 30, youth: 19, students: 37, women: 16, girls: 24, balavedi: 9 };
            } else if (this.user_level === 3) {
                this.member_lists = [
                    {
                        id: 1,
                        name: 'Unit 1',
                        counts: { wisdom: 4, youth: 3, students: 6, women: 2, girls: 4, balavedi: 1 },
                        totalOfficers: 20
                    },
                    {
                        id: 2,
                        name: 'Unit 2',
                        counts: { wisdom: 3, youth: 2, students: 4, women: 2, girls: 3, balavedi: 1 },
                        totalOfficers: 15
                    },
                    {
                        id: 3,
                        name: 'Unit 3',
                        counts: { wisdom: 5, youth: 3, students: 5, women: 3, girls: 3, balavedi: 2 },
                        totalOfficers: 21
                    }
                ];
                this.totalCounts = { wisdom: 12, youth: 8, students: 15, women: 7, girls: 10, balavedi: 4 };
            }

            // Update chart after a small delay to ensure DOM is ready
            this.$nextTick(() => {
                this.updateChart();
            });
            
            this.loading_list = false;
        },
        
        updateChart() {
            this.series = [
                this.totalCounts.wisdom,
                this.totalCounts.youth,
                this.totalCounts.students,
                this.totalCounts.women,
                this.totalCounts.girls,
                this.totalCounts.balavedi
            ];
        },
        
        viewDetails(sub_level) {
            if (this.user_level <= 2) {
                this.$router.push(`/org/${this.user_level + 1}/${sub_level.id}/election-officers-report`);
            } else {
                this.$router.push(`/org/${this.user_level + 1}/${sub_level.id}/election-officers-list`);
            }
        }
    }
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
    margin-bottom: 10px;
}

.stat-box .title {
    font-size: 12px;
    color: #6c757d;
    font-weight: 500;
}

.stat-box .value {
    font-size: 20px;
    font-weight: bold;
}

.wallet-card .balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: auto;
}

.left {
    margin-left: 20px;
}

.wallet-card {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 0px 16px;
    position: relative;
    z-index: 1;
    padding-bottom: 0px !important;
}

.custom-title {
    font-weight: 600;
    color: #27173E;
}

.font-dark {
    font-weight: 500;
}

.table th {
    font-size: 12px;
    text-align: center;
    background-color: #f8f9fa;
}

.table td {
    text-align: center;
    font-size: 14px;
    vertical-align: middle;
}

.table td:first-child {
    text-align: left;
}

.action-button-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.action-button-list li {
    margin-bottom: 10px;
}

.action-divider {
    height: 1px;
    background-color: #e9ecef;
    margin: 10px 0;
}

.btn-list {
    width: 100%;
    text-align: left;
    padding: 10px 15px;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-list:hover {
    background-color: #f8f9fa;
}

.chart-container {
    position: relative;
    width: 100%;
    max-width: 400px;
}

.right .chart-container {
    width: 100%;
}

@media (max-width: 576px) {
    .stat-box .value {
        font-size: 16px;
    }
    
    .table th,
    .table td {
        font-size: 11px;
        padding: 8px 4px;
    }
    
    .wallet-card .balance {
        flex-direction: column;
        align-items: center;
    }
    
    .left {
        margin-left: 0;
        text-align: center;
        margin-bottom: 15px;
    }
    
    .chart-container {
        width: 100%;
        max-width: 300px;
    }
}
</style>